import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { knowledgeAPI } from '../services/api';
import colors, { shadows } from '../theme';

function CreateKnowledgePage() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        content: '',
        category: 'technical',
        resources: '',
        assessment_type: 'acknowledgment'
    });
    const [quizQuestions, setQuizQuestions] = useState([
        { question: '', answers: ['', '', '', ''], correctAnswer: 0 }
    ]);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleQuizQuestionChange = (qIdx, field, value) => {
        const updated = [...quizQuestions];
        updated[qIdx][field] = value;
        setQuizQuestions(updated);
    };

    const handleQuizAnswerChange = (qIdx, aIdx, value) => {
        const updated = [...quizQuestions];
        updated[qIdx].answers[aIdx] = value;
        setQuizQuestions(updated);
    };

    const addQuestion = () => {
        setQuizQuestions([
            ...quizQuestions,
            { question: '', answers: ['', '', '', ''], correctAnswer: 0 }
        ]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const data = {
                ...formData,
                quiz_questions: formData.assessment_type === 'quiz' ? quizQuestions : undefined
            };

            await knowledgeAPI.create(data);
            navigate('/library');
        } catch (error) {
            console.error('Error creating knowledge:', error);
            alert('Error creating knowledge entry');
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', backgroundColor: colors.gray[100] }}>
            {/* Header */}

            {/* Content */}
            <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
                <div style={{ backgroundColor: colors.white, padding: '2rem', borderRadius: '8px', boxShadow: shadows.sm }}>
                    <form onSubmit={handleSubmit}>
                        {/* Title */}
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                Title *
                            </label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.5rem',
                                    border: `1px solid ${colors.gray[300]}`,
                                    borderRadius: '4px',
                                    fontSize: '1rem'
                                }}
                            />
                        </div>

                        {/* Description */}
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                Brief Description
                            </label>
                            <input
                                type="text"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                style={{
                                    width: '100%',
                                    padding: '0.5rem',
                                    border: `1px solid ${colors.gray[300]}`,
                                    borderRadius: '4px',
                                    fontSize: '1rem'
                                }}
                            />
                        </div>

                        {/* Category */}
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                Category
                            </label>
                            <select
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                                style={{
                                    width: '100%',
                                    padding: '0.5rem',
                                    border: `1px solid ${colors.gray[300]}`,
                                    borderRadius: '4px',
                                    fontSize: '1rem'
                                }}
                            >
                                <option value="technical">Technical</option>
                                <option value="process">Process</option>
                                <option value="onboarding">Onboarding</option>
                                <option value="communication">Communication</option>
                                <option value="other">Other</option>
                            </select>
                        </div>

                        {/* Content */}
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                Content *
                            </label>
                            <textarea
                                name="content"
                                value={formData.content}
                                onChange={handleChange}
                                required
                                rows="10"
                                style={{
                                    width: '100%',
                                    padding: '0.5rem',
                                    border: `1px solid ${colors.gray[300]}`,
                                    borderRadius: '4px',
                                    fontSize: '1rem',
                                    fontFamily: 'inherit'
                                }}
                            />
                        </div>

                        {/* Resources */}
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                Resources (optional URL)
                            </label>
                            <input
                                type="url"
                                name="resources"
                                value={formData.resources}
                                onChange={handleChange}
                                placeholder="https://..."
                                style={{
                                    width: '100%',
                                    padding: '0.5rem',
                                    border: `1px solid ${colors.gray[300]}`,
                                    borderRadius: '4px',
                                    fontSize: '1rem'
                                }}
                            />
                        </div>

                        {/* Assessment Type */}
                        <div style={{ marginBottom: '1.5rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                                Assessment Type *
                            </label>
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <input
                                        type="radio"
                                        name="assessment_type"
                                        value="acknowledgment"
                                        checked={formData.assessment_type === 'acknowledgment'}
                                        onChange={handleChange}
                                        style={{ marginRight: '0.5rem' }}
                                    />
                                    Simple Acknowledgment
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <input
                                        type="radio"
                                        name="assessment_type"
                                        value="quiz"
                                        checked={formData.assessment_type === 'quiz'}
                                        onChange={handleChange}
                                        style={{ marginRight: '0.5rem' }}
                                    />
                                    Quiz
                                </label>
                            </div>
                        </div>

                        {/* Quiz Questions */}
                        {formData.assessment_type === 'quiz' && (
                            <div style={{ backgroundColor: colors.gray[50], padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem' }}>
                                <h3 style={{ marginBottom: '1rem' }}>Quiz Questions</h3>
                                {quizQuestions.map((q, qIdx) => (
                                    <div key={qIdx} style={{ backgroundColor: colors.white, padding: '1rem', borderRadius: '8px', marginBottom: '1rem', border: `1px solid ${colors.gray[200]}` }}>
                                        <input
                                            type="text"
                                            value={q.question}
                                            onChange={(e) => handleQuizQuestionChange(qIdx, 'question', e.target.value)}
                                            placeholder={`Question ${qIdx + 1}`}
                                            style={{
                                                width: '100%',
                                                padding: '0.5rem',
                                                border: `1px solid ${colors.gray[300]}`,
                                                borderRadius: '4px',
                                                marginBottom: '0.75rem'
                                            }}
                                        />
                                        {q.answers.map((answer, aIdx) => (
                                            <div key={aIdx} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                                                <input
                                                    type="radio"
                                                    checked={q.correctAnswer === aIdx}
                                                    onChange={() => handleQuizQuestionChange(qIdx, 'correctAnswer', aIdx)}
                                                    style={{ marginRight: '0.5rem' }}
                                                />
                                                <input
                                                    type="text"
                                                    value={answer}
                                                    onChange={(e) => handleQuizAnswerChange(qIdx, aIdx, e.target.value)}
                                                    placeholder={`Answer ${aIdx + 1}`}
                                                    style={{
                                                        flex: 1,
                                                        padding: '0.5rem',
                                                        border: `1px solid ${colors.gray[300]}`,
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    onClick={addQuestion}
                                    style={{
                                        padding: '0.5rem 1rem',
                                        backgroundColor: colors.gray[200],
                                        color: colors.gray[700],
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '0.875rem'
                                    }}
                                >
                                    + Add Question
                                </button>
                            </div>
                        )}

                        {/* Buttons */}
                        <div style={{ display: 'flex', gap: '1rem' }}>
                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    padding: '0.75rem 1.5rem',
                                    backgroundColor: loading ? colors.gray[400] : colors.green[500],
                                    color: colors.white,
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    fontSize: '1rem'
                                }}
                            >
                                {loading ? 'Creating...' : 'Create & Assign to Team'}
                            </button>
                            <button
                                type="button"
                                onClick={() => navigate('/dashboard')}
                                style={{
                                    padding: '0.75rem 1.5rem',
                                    backgroundColor: colors.gray[200],
                                    color: colors.gray[700],
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '1rem'
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default CreateKnowledgePage;